import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  SHARE_USER_ACCOUNT_SETTINGS_CONFIG,
  ShareUserAccountSettingsConfig,
} from '../../share-user-account-settings.provider';
import { UserModels } from '@share-models';
import { api } from '../consts/api.const';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private http = inject(HttpClient);
  private config = inject<ShareUserAccountSettingsConfig>(
    SHARE_USER_ACCOUNT_SETTINGS_CONFIG,
  );

  public updateUserProfile(
    payload: UserModels.UpdateUserProfileData,
  ): Observable<UserModels.UserDocument> {
    return this.http.patch<UserModels.UserDocument>(
      `${this.userManagerUrl}/users`,
      payload,
    );
  }

  public requestEmailChange(
    email: string,
  ): Observable<{ _id?: string; id?: string }> {
    return this.http.post<{ _id?: string; id?: string }>(
      api.user.requestEmailChanges(this.config.apiUrl),
      { email },
    );
  }

  public me(accessToken: string): Observable<UserModels.UserDocument> {
    return this.http.put<UserModels.UserDocument>(
      api.user.getProfile(this.userManagerUrl, accessToken),
      {},
    );
  }

  private get userManagerUrl(): string {
    return this.config.userManagerUrl;
  }
}
